import { apiService } from '../../../shared/services/apiServices';
import technicianEndpoints from './technicianEndpoints';
import { TECHNICIAN_ERROR_MESSAGES } from '../errors';

const ERROR_MESSAGES = TECHNICIAN_ERROR_MESSAGES;

export const deleteMediaResource = async (
  path: string
): Promise<{ success: boolean; error?: string }> => {
  try {
    const result = await apiService.deleteAPI(
      technicianEndpoints.MEDIA_RESOURCES,
      { path }
    );

    if (result.error) {
      throw new Error(ERROR_MESSAGES.UNEXPECTED_ERROR);
    }

    return { success: true };
  } catch (_error) {
    throw new Error(ERROR_MESSAGES.UNEXPECTED_ERROR);
  }
};
